/**
 * Ton plakietki terminu na liście postępowań oferenta — jeden próg dla listy GK
 * i listy podwykonawcy. Sama karta ogłoszenia mieszka teraz w ProceedingOffererDetail
 * (pełna strona), więc tu został wyłącznie ten wspólny helper.
 */
export function offererDeadlineTone(deadline: string, open: boolean) {
  if (!open) return { color: "gray" as const, label: "Po terminie" };
  const hoursLeft = (new Date(deadline).getTime() - Date.now()) / 3_600_000;
  if (hoursLeft < 48) return { color: "red" as const, label: "Kończy się" };
  return { color: "green" as const, label: "Otwarte" };
}
